import { render, staticRenderFns } from "./exchange-codes.vue?vue&type=template&id=603a778a&scoped=true&"
import script from "./exchange-codes.vue?vue&type=script&lang=js&"
export * from "./exchange-codes.vue?vue&type=script&lang=js&"
import style0 from "./exchange-codes.vue?vue&type=style&index=0&id=603a778a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a778a",
  null
  
)

export default component.exports